import { vnTemplate } from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { validationsList_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { simpleConfirmDialog_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/simpleConfirmDialog_template";

declare var ko: any;

export class imagePickerAdd_template extends vnTemplate {

    protected parent: any;
    public validationsList: validationsList_template;
    public confirmDialog : simpleConfirmDialog_template

    protected getTemplateHtml(): string {

        return /* html */`

            <div class="w-img-picker-form" data-bind="css: { 'is-visible': isShown }, template: { afterRender: onLoadTemplate }">
                <div class="img-picker-form" id="add-image-upload-zone">
                    <div class="form-header">
                        <h3 class="section-title">Add a new image</h3>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }" ></button>
                    </div>

                    <div data-bind="css: { 'is-visible': isOptimizationWidthClaidOpen }" class="w-lightbox light-theme">
                        <div class="img-picker-content popup-warning">
                            <div class="w-form lightbox-form">
                                <div class="form-header">
                                    <h3 class="form-title">Optimize Images</h3>
                                </div>
                                <div class="form-body optimizer-body">
                                    <div class="form-group">
                                        <div class="opt-group">
                                            <p class="form-text">Would you like to apply AI image upscaling to the upload?</p>
                                            <div class="icon i-emaki-lab opt-icon"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-footer">
                                    <button type="button" data-bind="event: { click: uploadImages }" class="btn">No</button>
                                    <button type="button" data-bind="event: { click: uploadOptimizedImages }" class="btn opt-btn btn-form icon i-emaki-lab e-lab">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="form-body vertical-center center-content">
                        <progress id="progress-bar" max=100 value=0></progress>
                        <div style="color:red" data-bind="visible: uploadError">ERROR OCCURRED UPLOADING FILE</div>
                    </div>

                    ${ this.validationsList.getHtmlBuild() }
                    ${ this.confirmDialog.getHtmlBuild() }
                    <div class="form-body vertical-center center-content">
                        <div class="form-group">
                            <div class="from-droparea" id="drop-area" data-bind=" event: { drop: onDropFile }"></div>
                        </div>
                        <div class="form-group">
                            <span class="form-text">or</span>
                        </div>
                        <div class="form-group">
                            <input type="file" id="fileElem" name="fileElem[]" hidden accept="image/*" data-bind="event: { change: onAddFiles }" multiple>
                            <button type="button" class="btn dark" id="upload-button">Select Image</button>
                        </div>
                    </div>
                    <div class="form-footer">

                    </div>
                </div>
            </div>
            `;
    }

    private onLoadTemplate () {
        let dropArea = document.getElementById("drop-area");

        // Prevent default drag behaviors
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false)
            document.body.addEventListener(eventName, preventDefaults, false)
        });

        ;['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false)
        });

        ;['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false)
        });

        //dropArea.addEventListener('drop', this.handleDrop2, false);

        function highlight(e) {
            dropArea.classList.add('highlight');
        }

        function unhighlight(e) {
            dropArea.classList.remove('highlight');
        }

        function preventDefaults (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        let uploadButton = document.getElementById("upload-button");

        function triggerDialog (e) {
            let fileInput = document.getElementById("fileElem");
            fileInput.click();
        }

        uploadButton.addEventListener('click', triggerDialog, false);
    }


    public setParent(parent){

        this.parent = parent;
    }


    protected initPartial(): void {

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.confirmDialog = new simpleConfirmDialog_template("confirmDialog", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "imagePickerAdd-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            isShown: ko.observable(false),
            uploadError: ko.observable(false),
            isOptimizationWidthClaidOpen: ko.observable(false),
            optimizeWithClaid: ko.observable(false),
            files: ko.observableArray([]),
            event: ko.observable(null),
            onClickCancel: function(data, event){ self.onClickCancel();},
            onLoadTemplate: function(data, event){ self.onLoadTemplate();},
            onDropFile: function(data, event){ self.onDropFile(event);},
            onAddFiles: function(data, event, files){ self.onAddFiles(event);},
            uploadImages: function(data, event){ self.uploadImages();},
            uploadOptimizedImages: async function(data, event){ self.uploadOptimizedImages();},
        };
    }

    protected onClickCancel(){

        this.hide();
    }

    public setFiles(files){
        this.getTemplateViewModel().files(files);
    }

    public getFiles(){
        return this.getTemplateViewModel().files();
    }

    public showOptimizationWithClaidChoice(){
        this.getTemplateViewModel().isOptimizationWidthClaidOpen(true);
    }

    public hideOptimizationWithClaidChoice(){
        this.getTemplateViewModel().isOptimizationWidthClaidOpen(false);
    }

    public setOptimizeWithClaid(optimizeWithClaid){
        this.getTemplateViewModel().optimizeWithClaid(optimizeWithClaid);
    }

    public setImageResults(imageResults){
        this.getTemplateViewModel().imageResults(imageResults);
    }

    public addImageToResults(image){
        let results = this.getTemplateViewModel().imageResults;
        results().unshift(image);
        results.refresh(image,0);
        this.setSelectedImage(image);
    }

    public setSelectedImage(image){

        if(image){
            this.getTemplateViewModel().selectedImage(image);
            this.getTemplateViewModel().idImage(image.id);
            this.getTemplateViewModel().name(image.name);
            this.getTemplateViewModel().caption(image.caption);
            this.getTemplateViewModel().altText(image.altText);
        }else{
            this.getTemplateViewModel().selectedImage(null);
            this.getTemplateViewModel().idImage(null);
            this.getTemplateViewModel().name(null);
            this.getTemplateViewModel().caption(null);
            this.getTemplateViewModel().altText(null);
        }
    }

    protected async onAddFiles(event) {

        let files = event.target.files;
        for (let file of files) {
            if (file.type.indexOf('image') == -1) {
                return false;
            }
        }

        let validationResponse = await this.caller.validateImages(files);
        if(!validationResponse.valid){
            this.validationsList.setMessages(validationResponse.validations);
            return;
        }

        let keepGoing = await this.caller.checkImagesSizesInformation(files, event);
        if (!keepGoing) {
            return ;
        }

        this.setFiles(files);
        this.getTemplateViewModel().event(event);
        this.showOptimizationWithClaidChoice();
    }

    public async onDropFile(e) {

        this.getTemplateViewModel().event(event);
        let dt = e.dataTransfer;
        let files = dt.files;
        for (let file of files) {
            if (file.type.indexOf('image') == -1) {
                return false;
            }
        }

        let validationResponse = await this.caller.validateImages(files);
        if(!validationResponse.valid){
            this.validationsList.setMessages(validationResponse.validations);
            return;
        }

        let keepGoing = await this.caller.checkImagesSizesInformation(files, e);
        if (!keepGoing) {
            return ;
        }
        this.setFiles(files);
        this.showOptimizationWithClaidChoice();
    }

    public uploadImages(){

        this.setOptimizeWithClaid(false);
        this.hideOptimizationWithClaidChoice();
        let files = this.getFiles();
        let event = this.getTemplateViewModel().event();
        this.caller.handleFiles(files, event);
    }

    public async uploadOptimizedImages() {

        this.setOptimizeWithClaid(true);
        this.hideOptimizationWithClaidChoice();
        this.validationsList.clearMessages();
        this.getTemplateViewModel().uploadError(false);

        let files = this.getFiles();
        let event = this.getTemplateViewModel().event();

        this.caller.handleFiles(files, event, true);
    }

    public showUploadError(){

        this.getTemplateViewModel().uploadError(true);
    }

    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.validationsList.clearMessages();
        this.getTemplateViewModel().isShown(false);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerAdd_template.ts